import { Component, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import Swal from "sweetalert2";
import { environment } from '../../../../../../../environments/environment';
import { valuesys } from '../../../../../../../options';
import { etablissement, parcours, province } from '../../../../../model/db';
import { categorie, concerner } from '../../../../../model/pension';
import { AuthServiceService } from '../../../../../service/auth-service.service';
import { HelperService } from '../../../../../service/helper.service';
import { Translatable } from '../../../../../service/Translatable';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-demandewallet',
  templateUrl: './demandewallet.component.html',
  styleUrls: ['./demandewallet.component.scss']
})
export class DemandewalletComponent extends Translatable implements OnInit {

  public listDemandeWalletEnAttent: any = [];
  public listDemandeWalletEnRoler: any = [];
  etabId: any = ''
  endPOint: any = ""
  searchInput: any = "";
  searchCol: any = "";
  superAdmin: any = ""
  search: any = ""
  filtreSelect: any = 10;
  tri: any = "";
  order: any = "";
  child: any = "";
  filtreStatus: any = 0;
  statusEnroler: any = "A";
  endpointWithFitre: any;

  public searchColumn: string;
  public column: string;
  public childCol: string;
  public paginateListe: any = [];
  public nextPage: any = [];
  public prevPage: any = [];
  public lastPage: any = [];
  public firstPage: any = [];
  public currentPage: any = [];
  public total: any = [];
  public path: any = [];
  public lastNumPage: any = [];
  public infoData: any = [];
  public cPage_less_2: number;
  public path_cPage_less_2: any;
  public cPage_less_1: number;
  public path_cPage_less_1: any;
  public cPage_more_1: number;
  public path_cPage_more_1: any;
  public cPage_more_2: number;
  public path_cPage_more_2: any;
  etablissements: etablissement[] = [];
  dateDebut: string = this.formatDateYMD(new Date());
  dateFin: string = this.formatDateYMD(new Date());
  activeEtabId: number;
  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private helper: HelperService,
    private formBuilder: FormBuilder,
    private http: HttpClient) {
    super()
  }

  async ngOnInit() {
    this.auth.initAutority('DEW');

    let userinfo = this.auth.account()

    this.superAdmin = userinfo.info.admin;
    this.activeEtabId = userinfo.info.etablissement_id;
    if (this.superAdmin == 0) this.etabId = userinfo.info.etablissement_id;
    this.etablissements = await this.helper.getSelectList(environment.etablissement, ['name']);
    this.endPOint = environment.demande_wallet + "?page=1";
    if (this.superAdmin == 0) this.getListDemandeWalletEnAttent(this.endPOint, "")
    else this.getListDemandeWalletEnAttent(this.endPOint, '')


  }

  async getSearchInput() {
    this.getListDemandeWalletEnAttent(this.endPOint)
  }

  async getFiltreSelect() {
    this.getListDemandeWalletEnAttent(this.endPOint)
  }

  async getListDemandeWalletEnAttent(url, filtreAdd = "", col = "", refElement?: any, child?: any, searchMulti?: any) {

    if (refElement) {
      this.searchColumn = refElement.value
      this.column = col
      this.childCol = child
    }
    // this.filtreBase=true
    let filtreDate;

      if( this.dateDebut > this.dateFin ){
        console.log(this.dateDebut)
        console.log(this.dateFin)
        this.toastr.warning(this.__('msg.dateDebut_dateFin_error'),this.__("msg.warning"));
        return;
      }else{
         filtreDate = "&date_debut="+this.dateDebut +"&date_fin="+this.dateFin;
      }
      this.search = filtreDate;

    console.log("COL :" + col)
    console.log("filtreadd :" + filtreAdd)
    console.log("Search column :" + this.searchColumn)
    if (col != "" || this.searchColumn) {
      if (this.searchColumn != "" && this.searchColumn != "undefined") {
        if (this.superAdmin == 1)
          this.searchCol = "," + this.column + "|l|" + this.searchColumn;
        else
          this.searchCol = "," + this.column + "|l|" + this.searchColumn;
      } else if (this.searchColumn == "") {
        this.searchCol = "";
      }
    } else {

      if (col != "" || this.searchColumn) {
        if (this.searchColumn != "" && this.searchColumn != "undefined") {
          this.searchCol = "," + this.childCol + "." + this.column + "|l|" + this.searchColumn + "";
        } else if (this.searchColumn == "") {
          this.searchCol = "";
        }
      } else {
        if (this.searchInput != "" && this.searchInput != "undefined") {
          this.searchCol = "&where_or=concernees.matricule |l|" + this.searchInput + ",concernees.nom|l|" + this.searchInput + ",concernees.telephone|l|" + this.searchInput + ",concernees.email|l|" + this.searchInput + ",concernees.prenom|l|" + this.searchInput;
        } else if (this.searchInput == "") {
          this.searchCol = "";
        }
      }
    }

    let whereEtab = "";
    if (this.superAdmin == 0) {
      whereEtab = ",demande_wallet.etablissement_id|e|" + this.etabId;
    } else {
      whereEtab = "";
    }
    let filtreStatus = "";
    if (this.etabId == '') {
      filtreStatus = "&where=demande_wallet.statut|e|" + this.filtreStatus;
    } else {
      if (filtreAdd != "")
        filtreStatus = "&where=demande_wallet.statut|e|" + this.filtreStatus + whereEtab;
      else
        filtreStatus = "";
    }





    let filtre: any = "";
    if (this.filtreSelect != "" && this.filtreSelect != "undefined") {
      filtre = "&per_page=" + this.filtreSelect;
    }

    let triage: any = "";
    if (this.tri != "" && this.tri != "undefined") {
      triage = "&__order__=" + this.order + "," + this.tri;
    }
    // let toogle = await this.http.get<any>(url + filtreStatus + filtreAdd +filtre + triage + this.search ,valuesys.httpAuthOptions()).toPromise();

    let toogle = await this.http.get<any>(url + filtreStatus + filtreAdd +this.searchCol+ filtre + triage + this.search, valuesys.httpAuthOptions()).toPromise();
    this.listDemandeWalletEnAttent = toogle.data.data;
    console.log("Liste  voir", this.listDemandeWalletEnAttent)


    if (this.etabId == '') {
      this.path = environment.demande_wallet
      this.currentPage = toogle.data.current_page;
      this.firstPage = this.path + "?page=1";
      this.prevPage = this.path + "?page=" + (this.currentPage - 1);
      this.nextPage = this.path + "?page=" + (this.currentPage + 1);
      this.lastPage = this.path + "?page=" + toogle.data.last_page;
      this.lastNumPage = toogle.data.last_page;
      this.total = toogle.data.total;


      this.cPage_less_2 = 0
      this.cPage_less_1 = 0
      if (this.currentPage > 1) {

        if (this.currentPage > 2) {
          this.cPage_less_2 = this.currentPage - 2
          this.path_cPage_less_2 = this.path + "?page=" + this.cPage_less_2;
        }

        this.cPage_less_1 = this.currentPage - 1
        this.path_cPage_less_1 = this.path + "?page=" + this.cPage_less_1;
      }


      this.cPage_more_1 = 0
      this.cPage_more_2 = 0
      if (this.currentPage < this.lastNumPage) {
        this.cPage_more_1 = this.currentPage + 1
        this.path_cPage_more_1 = this.path + "?page=" + this.cPage_more_1;

        if (this.currentPage < this.lastNumPage - 1) {
          this.cPage_more_2 = this.currentPage + 2
          this.path_cPage_more_2 = this.path + "?page=" + this.cPage_more_2;
        }

      }

      let info = this.__('datatable.info').replace('_START_', toogle.data.from)
      let info2 = info.replace('_END_', toogle.data.to)
      this.infoData = info2.replace('_TOTAL_', toogle.data.total)
    }
    else {
      this.path = this.endpointWithFitre + ",demande_wallet.statut|e|" + this.filtreStatus + whereEtab;
      console.log('teste',this.endpointWithFitre)
      this.currentPage = toogle.data.current_page;
      this.firstPage = this.path + "&page=1";
      this.prevPage = this.path + "&page=" + (this.currentPage - 1);
      this.nextPage = this.path + "&page=" + (this.currentPage + 1);
      this.lastPage = this.path + "&page=" + toogle.data.last_page;
      this.lastNumPage = toogle.data.last_page;
      this.total = toogle.data.total;




      this.cPage_less_2 = 0
      this.cPage_less_1 = 0
      if (this.currentPage > 1) {

        if (this.currentPage > 2) {
          this.cPage_less_2 = this.currentPage - 2
          this.path_cPage_less_2 = this.path + "&page=" + this.cPage_less_2;
        }

        this.cPage_less_1 = this.currentPage - 1
        this.path_cPage_less_1 = this.path + "&page=" + this.cPage_less_1;
      }


      this.cPage_more_1 = 0
      this.cPage_more_2 = 0
      if (this.currentPage < this.lastNumPage) {
        this.cPage_more_1 = this.currentPage + 1
        this.path_cPage_more_1 = this.path + "&page=" + this.cPage_more_1;

        if (this.currentPage < this.lastNumPage - 1) {
          this.cPage_more_2 = this.currentPage + 2
          this.path_cPage_more_2 = this.path + "&page=" + this.cPage_more_2;
        }

      }

      let info = this.__('datatable.info').replace('_START_', toogle.data.from)
      let info2 = info.replace('_END_', toogle.data.to)
      this.infoData = info2.replace('_TOTAL_', toogle.data.total)
    }
    // this.path = environment.demande_wallet+"?page=1&where=demande_wallet.statut|e|0";     

  }

  async getFiltreStatus(status: any = '') {
    if (status == "A") this.filtreStatus = 0;
    if (status == "R") this.filtreStatus = 1;
    if (status == "E") this.filtreStatus = 2;
    console.log("Status", this.filtreStatus)
    let etabselect = "";

    if (this.etabId !== '') {
      this.endpointWithFitre = environment.demande_wallet + "?where=demande_wallet.etablissement_id|e|" + this.etabId
      etabselect = ",demande_wallet.etablissement_id|e|" + this.etabId
    }
    this.getListDemandeWalletEnAttent(environment.demande_wallet + "?page=1", etabselect);
  }
  filtreByEtablissement() {
    let etabselect = "";
    if (this.etabId !== '') {
      this.endpointWithFitre = environment.demande_enrolement + "?where=demande_wallet.etablissement_id|e|" + this.etabId
      etabselect = ",demande_wallet.etablissement_id|e|" + this.etabId
    }
    // this.endPOint = environment.demande_enrolement + "?page=1";
     this.getListDemandeWalletEnAttent(this.endPOint, ",demande_wallet.etablissement_id|e|" + this.etabId)
  }
  formatDateYMD(date: Date) {
    return date.toISOString().split('T')[0];
  }
}
